var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.vpnSettings.ServiceType === _vm.VpnServiceType.OpenVpn)?_c('network-vpn-settings-display-open-vpn',{attrs:{"vpn-settings":_vm.vpnSettings}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }